export default () => {
  const enlarge_bottom = document.querySelectorAll('.js-enlarge-bottom');
  if (enlarge_bottom) {
    enlarge_bottom.forEach(item => {
      let bottom = item.querySelector('.ProductCard__Bottom');
      bottom.setAttribute('data-height', bottom.scrollHeight);
    });
  }
}